import KG_B from "../../../../images/KG_B.png";
import KG_W from "../../../../images/KG_W.png";
import EY_S from "../../../../images/EY_S.png";

let underAttackSquares = [];

function RookScopeAttack(positionX, positionY, isWhiteTurn) {
	// Top
	for (let a = positionY + 1; a <= 8; a++) {
		underAttackSquares.push(parseInt(`${positionX}${a}`));
		if (detectPiece(`${positionX}${a}`, isWhiteTurn) === "piece") break;
		// if (document.getElementById(`P${positionX}${a}`).src !== EY_S) break;
	}

	// Bottom
	for (let a = positionY - 1; a >= 1; a--) {
		underAttackSquares.push(parseInt(`${positionX}${a}`));
		if (detectPiece(`${positionX}${a}`, isWhiteTurn) === "piece") break;
		// if (document.getElementById(`P${positionX}${a}`).src !== EY_S) break;
	}

	// Right
	for (let a = positionX + 1; a <= 8; a++) {
		underAttackSquares.push(parseInt(`${a}${positionY}`));
		if (detectPiece(`${a}${positionY}`, isWhiteTurn) === "piece") break;
		// if (document.getElementById(`P${a}${positionY}`).src !== EY_S) break;
	}

	// Left
	for (let a = positionX - 1; a >= 1; a--) {
		underAttackSquares.push(parseInt(`${a}${positionY}`));
		if (detectPiece(`${a}${positionY}`, isWhiteTurn) === "piece") break;
		// if (document.getElementById(`P${a}${positionY}`).src !== EY_S) break;
	}
}

function KnightScopeAttack(positionX, positionY) {
	if (positionX <= 7 && positionY <= 6) underAttackSquares.push(parseInt(`${positionX + 1}${positionY + 2}`)); // Top Right
	if (positionX >= 2 && positionY <= 6) underAttackSquares.push(parseInt(`${positionX - 1}${positionY + 2}`)); // Top Left
	if (positionX <= 6 && positionY <= 7) underAttackSquares.push(parseInt(`${positionX + 2}${positionY + 1}`)); // Right Top
	if (positionX <= 6 && positionY >= 2) underAttackSquares.push(parseInt(`${positionX + 2}${positionY - 1}`)); // Right Bottom
	if (positionX <= 7 && positionY >= 3) underAttackSquares.push(parseInt(`${positionX + 1}${positionY - 2}`)); // Bottom Right
	if (positionX >= 2 && positionY >= 3) underAttackSquares.push(parseInt(`${positionX - 1}${positionY - 2}`)); // Bottom Left
	if (positionX >= 3 && positionY <= 7) underAttackSquares.push(parseInt(`${positionX - 2}${positionY + 1}`)); // Left Top
	if (positionX >= 3 && positionY >= 2) underAttackSquares.push(parseInt(`${positionX - 2}${positionY - 1}`)); // Left Bottom
}
function BishopScopeAttack(positionX, positionY, isWhiteTurn) {
	// Right Top
	for (let a = 1; a <= 8 && positionX !== 8 && positionY !== 8 && positionX + a !== 9 && positionY + a !== 9; a++) {
		underAttackSquares.push(parseInt(`${positionX + a}${positionY + a}`));
		if (detectPiece(`${positionX + a}${positionY + a}`, isWhiteTurn) === "piece") break;
		// if (document.getElementById(`P${positionX + a}${positionY + a}`).src !== EY_S) break;
	}

	// Right Bottom
	for (let a = 1; a <= 8 && positionX !== 8 && positionY !== 1 && positionX + a !== 9 && positionY - a !== 0; a++) {
		underAttackSquares.push(parseInt(`${positionX + a}${positionY - a}`));
		if (detectPiece(`${positionX + a}${positionY - a}`, isWhiteTurn) === "piece") break;
		// if (document.getElementById(`P${positionX + a}${positionY - a}`).src !== EY_S) break;
	}

	// Left Top
	for (let a = 1; a <= 8 && positionX !== 1 && positionY !== 8 && positionX - a !== 0 && positionY + a !== 9; a++) {
		underAttackSquares.push(parseInt(`${positionX - a}${positionY + a}`));
		if (detectPiece(`${positionX - a}${positionY + a}`, isWhiteTurn) === "piece") break;
		// if (document.getElementById(`P${positionX - a}${positionY + a}`).src !== EY_S) break;
	}

	// Left Bottom
	for (let a = 1; a <= 8 && positionX !== 1 && positionY !== 1 && positionX - a !== 0 && positionY - a !== 0; a++) {
		underAttackSquares.push(parseInt(`${positionX - a}${positionY - a}`));
		if (detectPiece(`${positionX - a}${positionY - a}`, isWhiteTurn) === "piece") break;
		// if (document.getElementById(`P${positionX - a}${positionY - a}`).src !== EY_S) break;
	}
}

function KingScopeAttack(positionX, positionY) {
	if (positionY !== 8) underAttackSquares.push(parseInt(`${positionX}${positionY + 1}`)); // Top
	if (positionX !== 8 && positionY !== 8) underAttackSquares.push(parseInt(`${positionX + 1}${positionY + 1}`)); // Top Right
	if (positionX !== 8) underAttackSquares.push(parseInt(`${positionX + 1}${positionY}`)); // Right
	if (positionX !== 8 && positionY !== 1) underAttackSquares.push(parseInt(`${positionX + 1}${positionY - 1}`)); // Bottom  Right
	if (positionY !== 1) underAttackSquares.push(parseInt(`${positionX}${positionY - 1}`)); // Bottom
	if (positionX !== 1 && positionY !== 1) underAttackSquares.push(parseInt(`${positionX - 1}${positionY - 1}`)); // Bottom Left
	if (positionX !== 1) underAttackSquares.push(parseInt(`${positionX - 1}${positionY}`)); // Left
	if (positionX !== 1 && positionY !== 8) underAttackSquares.push(parseInt(`${positionX - 1}${positionY + 1}`)); // Left Top
}

function PawnScopeAttack(positionX, positionY, isWhiteTurn) {
	if (isWhiteTurn) {
		if (positionX !== 8) underAttackSquares.push(parseInt(`${positionX + 1}${positionY + 1}`)); // White Front Right
		if (positionX !== 1) underAttackSquares.push(parseInt(`${positionX - 1}${positionY + 1}`)); // White Front Left
	} else {
		if (positionX !== 8) underAttackSquares.push(parseInt(`${positionX + 1}${positionY - 1}`)); // Black Front Right
		if (positionX !== 1) underAttackSquares.push(parseInt(`${positionX - 1}${positionY - 1}`)); // Black Front Left
	}
}

function detectPiece(position, isWhiteTurn) {
	const square = document.getElementById(`P${position}`);
	if (square.src !== EY_S) {
		if (isWhiteTurn && square.src !== KG_B) return "piece";
		if (!isWhiteTurn && square.src !== KG_W) return "piece";
	}
}

export function isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, target) {
	isWhiteTurn = !isWhiteTurn;
	underAttackSquares = [];
	let pieces = isWhiteTurn ? whitePiece : blackPiece;
	let position = isWhiteTurn ? whitePosition : blackPosition;

	pieces.forEach((piece, index) => {
		// Checking if the piece has not been captured
		if (typeof position[index] === "number") {
			const positionX = parseInt(`${position[index]}`[0]);
			const positionY = parseInt(`${position[index]}`[1]);

			switch (piece) {
				case "RK_B":
				case "RK_W":
					RookScopeAttack(positionX, positionY, isWhiteTurn); // DEBUG // console.log("ROOK:", positionX, positionY);
					break;
				case "KT_B":
				case "KT_W":
					KnightScopeAttack(positionX, positionY); // DEBUG // console.log("KNIGHT:", positionX, positionY);
					break;
				case "BP_B":
				case "BP_W":
					BishopScopeAttack(positionX, positionY, isWhiteTurn); // DEBUG // console.log("BISHOP:", positionX, positionY);
					break;
				case "QN_B":
				case "QN_W":
					RookScopeAttack(positionX, positionY, isWhiteTurn); // DEBUG // console.log("QUEEN:", positionX, positionY);
					BishopScopeAttack(positionX, positionY, isWhiteTurn);
					break;
				case "KG_B":
				case "KG_W":
					KingScopeAttack(positionX, positionY); // DEBUG // console.log("KING:", positionX, positionY, );
					break;
				case "PN_B":
				case "PN_W":
					PawnScopeAttack(positionX, positionY, isWhiteTurn); // DEBUG // console.log("PAWN:", positionX, positionY, isWhiteTurn);
					break;
			}
		}
	}); // DEBUG // console.log(underAttackSquares);
	// underAttackSquares.forEach(item => {
	// 	document.getElementById(`P${item}`).style.backgroundColor = "rgb(125, 125, 255)";
	// });
	// document.getElementById(`P${positionX}${positionY}`).style.backgroundColor = "rgb(125, 125, 255)";
	if (underAttackSquares.includes(target)) return true;
	else return false;
}
